import request from '@/utils/request'
import qs from 'qs'

export function audienceLogin(params) {
  return request({
    url: '/user/login',
    method: 'post',
    data: qs.stringify(params)
  })
}
export function insertPic(params) {
  return request({
    url: '/sysPic/insertPic',
    method: 'post',
    data:params
  })
}
export function fileUpload(data) {
	console.log(data)
  return request({
    url: '/file/upload',
    method: 'post',
    data:data,
	headers: {'Content-Type': 'multipart/form-data'}
  })
}
export function audienceRegister(params) {
  return request({
    url: '/user/audienceRegister',
    method: 'post',
    data: qs.stringify(params)
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js